import { LimitedBannerStyled } from '@/components/LimitedBanner/styled';
import UpgradeBtn from '@/components/UpgradeBtn';
import { PricingPlan } from '@/constants/enum';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { Banner } from '@shopify/polaris';
import { ReactNode, useState } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  title: string;
  content: ReactNode;
  actions?: ReactNode;
}

const LimitedBanner = ({ title, content, actions }: IProps) => {
  const [show, setShow] = useState(true);
  const isSkip = useSelector(isSkipApiSelector);
  const { data: dataSetting } = apiCaller.useGeneralSettingsQuery(undefined, { skip: isSkip });
  return [PricingPlan.Free, PricingPlan.Basic].includes(dataSetting?.data?.plan || PricingPlan.Free) && show ? (
    <LimitedBannerStyled className="mt-8 mb-16">
      <Banner
        title={title}
        onDismiss={() => {
          setShow(false);
        }}
        tone="info"
      >
        {content}
        <div className="mt-8">{actions || <UpgradeBtn />}</div>
      </Banner>
    </LimitedBannerStyled>
  ) : null;
};

export default LimitedBanner;
